export const WELD_PRICING_URL = "https://weld.app/pricing";

export const WELD_PLAN_COMPARISON_TABLE_URL =
  "https://weld.app/pricing#comparison-table";

export const WELD_TERMS_OF_SERVICE_URL = "https://weld.app/terms-of-service";
export const WELD_PRIVACY_POLICY_URL = "https://weld.app/privacy-policy";
